import { useConfig, useDispatch, useMachineState } from '../app/context';
import { cx } from '../components/cx';
import { ArrowUpRightIcon } from '../components/icons';
import common from './common.module.css';
import styles from './WardScreen.module.css';

export function WardScreen() {
  const { unitId } = useConfig();
  const { wards } = useMachineState();
  const dispatch = useDispatch();

  return (
    <section
      className={cx(common.screen, common.fadeUp, styles.screen)}
      aria-labelledby="ward-title"
    >
      <div className={cx(common.header, styles.header)}>
        <div>
          <div className={common.kicker}>ZONE ASSIGNMENT</div>
          <h2 id="ward-title" className={common.title}>
            Select Ward
          </h2>
        </div>
        <div className={styles.readiness}>CONNECTED · {unitId} · READY</div>
      </div>
      <div className={styles.grid}>
        {wards.map((ward) => (
          <button
            key={ward.code}
            type="button"
            className={cx(common.tile, styles.card)}
            onClick={() => dispatch({ type: 'SELECT_WARD', ward })}
          >
            <div className={styles.cardTop}>
              <div className={common.label}>ZONE {ward.code}</div>
              <ArrowUpRightIcon size={20} className={styles.arrow} />
            </div>
            <h3 className={styles.name}>{ward.name}</h3>
            <div className={styles.meta}>
              <span>{ward.beds} BED UNITS</span>
              <span className={styles.separator} aria-hidden>
                |
              </span>
              <span>LAST CYCLE {ward.lastCycle}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
